/**
 * Arabic for runway and taxiway closures carried to the platform — the map's
 * CLOSURES pane and what the shell says when the platform answers.
 * Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  "{surface} closure under {notam} saved on the platform. It starts on time.":
    "حُفظ إغلاق {surface} بموجب {notam} على المنصة. يبدأ في موعده.",
  "{surface} closed under {notam}. Saved on the platform.": "أُغلق {surface} بموجب {notam}. حُفظ على المنصة.",
  "This closure is not on the platform, so it cannot be lifted there.":
    "هذا الإغلاق غير مسجّل على المنصة، فلا يمكن رفعه هناك.",
  "{surface} reopened. {notam} lifted on the platform.": "أُعيد فتح {surface}. رُفع {notam} على المنصة.",
  "Only a supervisor, an accountable manager or an administrator can close a surface.":
    "لا يغلق السطح إلا المشرف أو المدير المسؤول أو مسؤول النظام.",
  "Say why it is closed.": "اذكر سبب الإغلاق.",
  "Say whether it is planned works or unplanned.": "حدّد هل هي أعمال مخططة أم إغلاق غير مخطط.",
  "The end must be after the start.": "يجب أن تكون النهاية بعد البداية.",
  "An unplanned closure starts now or earlier. Choose planned for a later start.":
    "الإغلاق غير المخطط يبدأ الآن أو قبل ذلك. اختر «أعمال مخططة» لبداية لاحقة.",
  "You cannot read the closure register: {why}. Only closures you recorded show here.":
    "لا يمكنك قراءة سجل الإغلاقات: {why}. تظهر هنا الإغلاقات التي سجّلتها فقط.",
  "Could not read the closure register just now: {why}. This list may be out of date.":
    "تعذّرت قراءة سجل الإغلاقات الآن: {why}. قد تكون هذه القائمة غير محدّثة.",
  "Planned or unplanned": "مخطط أم غير مخطط",
  "Planned or unplanned?": "مخطط أم غير مخطط؟",
  "Planned works": "أعمال مخططة",
  "Your role cannot close a surface.": "دورك لا يسمح بإغلاق سطح.",
  "The platform did not take this closure: {why}": "لم تقبل المنصة هذا الإغلاق: {why}",
  "Lifting on the platform…": "جارٍ رفع الإغلاق على المنصة…",
  "The platform did not take the lift: {why}": "لم تقبل المنصة رفع الإغلاق: {why}",
};

export default ar;
